module.exports = __webpack_public_path__ + "img/43.62177cf1.gif";